var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0162 1.48214C9.26101 1.23772 9.65751 1.23772 9.90233 1.48214L17.0567 8.62504C17.5951 9.16257 17.2144 10.0827 16.4536 10.0827H15.365V16.4971C15.365 16.7918 15.1262 17.0306 14.8315 17.0306L11.0217 17.0306C10.727 17.0306 10.4882 16.7917 10.4882 16.4971V13.5471C10.4882 13.4292 10.3926 13.3337 10.2748 13.3337H8.52609C8.40824 13.3337 8.3127 13.4292 8.3127 13.5471V16.4971C8.3127 16.7918 8.07384 17.0306 7.7792 17.0306H4.08632C3.79168 17.0306 3.55283 16.7918 3.55283 16.4971V10.0827H2.46492C1.70412 10.0827 1.32343 9.16258 1.86182 8.62504L3.84602 6.64403L3.84608 2.515C3.84608 2.29107 4.02761 2.10955 4.25153 2.10955H6.17368C6.39761 2.10955 6.57914 2.29108 6.57914 2.515V3.9153L9.0162 1.48214Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b5f1e04d2bf5ee7784323a6c46525765.svg";
export { ForwardRef as ReactComponent };